import { Colors, Spacing } from "@constants"
import { StyleSheet } from "react-native"

export const EstablishmentSelectionStyles = (isMobile: boolean) =>
  StyleSheet.create({
    container: {
      width: "100%",
      alignItems: "center",
      maxWidth: isMobile ? "100%" : 400,
      backgroundColor: Colors.white,
    },
    listContainer: {
      width: "100%",
      marginBottom: Spacing.L,
      zIndex: 10,
      backgroundColor: Colors.white,
      position: "relative",
    },
    textHoldingInputContainer: {
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    holdingList: {
      backgroundColor: Colors.white,
      borderWidth: 1,
      borderColor: Colors.border1,
      borderRadius: 8,
      paddingVertical: Spacing.M,
      width: "100%",
      position: "absolute",
      top: "100%",
      maxHeight: 260,
      zIndex: 50,
    },
    titleText: {
      textAlign: "left",
      marginBottom: Spacing.S,
    },
    subtitleText: {
      textAlign: "left",
      color: Colors.darkGrey,
      marginBottom: Spacing.L,
      whiteSpace: isMobile ? "normal" : "nowrap",
    },
    infoContainer: {
      marginBottom: Spacing.L,
    },
    cancelButton: {
      borderColor: Colors.darkGrey,
      marginTop: Spacing.L,
    },
    cancelButtonText: {
      color: Colors.lightGray,
      fontSize: 16,
      alignContents: "center",
    },
    infoBoxTitle: {
      paddingLeft: Spacing.S,
      fontWeight: "bold",
    },
    infoBoxHelpStatement: {
      marginTop: Spacing.M,
      textAlign: "center",
      fontWeight: "500",
    },
  })

export const inputContainerStyles = {
  textInputContainer: { width: "100%", margin: 0 },
  mainContainer: { width: "100%", alignItems: "center" as const },
  textInputStyle: { width: "100%" },
}
